// Lightweight wrapper around the project snackbar so super-admin pages can
// fire-and-forget notifications without hand-rolling the redux payload.

import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

const fire = (variant, message) =>
  dispatch(
    openSnackbar({
      open: true,
      message,
      variant: 'alert',
      alert: { color: variant },
      close: false
    })
  );

export const notify = {
  success: (msg) => fire('success', msg),
  error: (msg) => fire('error', msg),
  info: (msg) => fire('info', msg),
  warn: (msg) => fire('warning', msg)
};

// Pulls the human-readable failure reason out of a /api/super/* error response.
// The backend wraps errors as { data, error: true, message } — fall back to
// the Axios error message if the body isn't there.
export const apiErrorMessage = (err, fallback = 'Request failed.') => {
  return err?.response?.data?.message || err?.message || fallback;
};

// Some /api/super/* endpoints respond with the documented envelope
// { data: <payload>, error, message } while others (notably the tenant +
// reference-data DRF viewsets) return DRF's bare shape at the top level.
// This helper accepts either.
export const unwrap = (res) => {
  const body = res?.data;
  if (body == null) return null;
  if (typeof body === 'object' && 'error' in body && 'message' in body && 'data' in body) {
    return body.data;
  }
  return body;
};

// Convenience for paginated list endpoints.
export const unwrapList = (res) => {
  const payload = unwrap(res);
  if (Array.isArray(payload)) return { count: payload.length, results: payload };
  return { count: payload?.count || 0, results: payload?.results || [] };
};
